import { tw } from 'utils/classnames'

interface ButtonIconProps {
  className?: string
  onClick: () => void
  icon: React.ReactNode
  children: React.ReactNode
}

/**
 * Button icon for product page. Icon on the left and text on the right. Text does not break line.
 */
export const ButtonIcon = (props: ButtonIconProps) => {
  return (
    // oxlint-disable-next-line react/button-has-type
    <button
      className={tw(
        'bg-cf-white rounded-2 hover:shadow-cf-elevation-light-1 grow-0 border border-[#E2D9F2] font-medium',
        'flex items-center justify-center gap-2 p-2 px-4',
        props.className,
      )}
      onClick={props.onClick}
    >
      {props.icon}
      <span className="whitespace-nowrap">{props.children}</span>
    </button>
  )
}
